import { guideSteps, updateLog } from "@/mocks/platforms";

export default function GuideSection() {
  return (
    <section id="guide" className="bg-background-100 py-16 md:py-24 border-y border-background-200">
      <div className="mx-auto max-w-shell px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12">
          <div className="lg:col-span-8">
            <span className="text-xs font-label tracking-[0.2em] text-primary-600 uppercase">How to choose</span>
            <h2 className="mt-3 font-heading font-bold text-foreground-950 text-2xl md:text-4xl">四步挑到对味的爆料网站</h2>
            <p className="mt-3 max-w-2xl text-sm md:text-base leading-relaxed text-foreground-600">
              排名只是起点。真正决定你会不会长期停留的，是更新节奏、信息出处和讨论氛围。照着下面四步走一遍，基本不会踩坑。
            </p>

            <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5">
              {guideSteps.map((step) => (
                <div key={step.id} className="rounded-lg bg-background-50 border border-background-200 p-5">
                  <div className="flex items-center justify-between">
                    <span className="w-10 h-10 flex items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
                      <i className={`${step.icon} text-lg`}></i>
                    </span>
                    <span className="font-heading text-3xl font-bold text-background-300">{step.step}</span>
                  </div>
                  <h3 className="mt-4 font-heading font-semibold text-base text-foreground-950">{step.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-600">{step.desc}</p>
                </div>
              ))}
            </div>
          </div>

          <aside className="lg:col-span-4">
            <div className="rounded-lg bg-background-50 border border-background-200 p-5 md:p-6">
              <div className="flex items-center gap-2">
                <span className="w-8 h-8 flex items-center justify-center rounded-md bg-primary-100 text-primary-700">
                  <i className="ri-history-line"></i>
                </span>
                <h3 className="font-heading font-bold text-base text-foreground-950">榜单更新日志</h3>
              </div>
              <ul className="mt-5 space-y-4">
                {updateLog.map((log) => (
                  <li key={log.id} className="flex gap-3">
                    <span className="font-heading text-xs font-bold text-primary-600 pt-0.5 whitespace-nowrap">{log.date}</span>
                    <span className="text-sm leading-relaxed text-foreground-600">{log.text}</span>
                  </li>
                ))}
              </ul>

              <div className="mt-6 rounded-md bg-accent-100/70 border border-accent-200 p-4">
                <p className="flex items-center gap-2 text-sm font-medium text-accent-900">
                  <i className="ri-information-line"></i>
                  收录标准
                </p>
                <p className="mt-2 text-xs leading-relaxed text-accent-900/80">
                  平台需连续更新满 6 个月、内容板块结构清晰、且无长期无法访问记录，才会进入正式榜单。
                </p>
              </div>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}